module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_resort@3x-c7df33fd6fd54a0340c639ccabd29f48.webp";